<template>
    <div>
        <div class>
            <h3>Undertaking</h3>
        </div>
        <tabs nav-style="tabs" v-model="activeTabIndex">
            <tab header="Undertaking Summary">
                <div class="wrapper">
                    <loader v-if="loading" />
                    <fieldset :disabled="formDisabled">
                        <form v-if="!loading" class="form form-horizontal" @submit.prevent data-vv-scope="undertaking">
                            <div class="form-group">
                                <label class="col-md-2 control-label">DB Number</label>
                                <div class="col-md-8" style="margin-top: 10px;">{{ undertaking.dbNumber}}</div>
                            </div>
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('undertaking.name') }">
                                <label class="col-md-2 control-label">Undertaking Name</label>
                                <div class="col-md-8">
                                    <input class="form-control" type="text" name="name" v-model="undertaking.name" v-validate="'required'" aria-required="true">
                                    <span v-show="errors.has('undertaking.name')" class="has-error">Undertaking Name is required</span>
                                </div>
                            </div>
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('undertaking.agencyId') }">
                                <label class="col-md-2 control-label">Lead Agency</label>
                                <div class="col-md-8">
                                    <select name="agencyId" class="form-control" v-model="undertaking.agencyId" v-validate="'required'" aria-required="true">
                                        <option :value="null">Select an Agency</option>
                                        <option v-for="agency in agencyOrgList" :key="agency.id" :value="agency.id">{{ agency.description}}</option>
                                    </select>
                                    <span v-show="errors.has('undertaking.agencyId')" class="has-error">Lead Agency is required</span>
                                    <span v-show="selectedLeadAgency && selectedLeadAgency.hasUsers === false && !selectedLeadAgency.agencyNoReview" class="has-error">
                                        Selected Lead Agency has no Wyotrack users
                                    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label">Agency Undertaking No</label>
                                <div class="col-md-8">
                                    <input class="form-control" type="text" name="agencyUndertakingNo" v-model="undertaking.agencyUndertakingNo">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label">Number of Undertaking Actions</label>
                                <div class="col-md-2">
                                    <input class="form-control" type="number" min="0" name="numberOfActions" v-model="undertaking.numberOfActions">
                                </div>
                            </div>
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('undertaking.reqMoa') || errors.has('undertaking.reqPa') }">
                                <label class="col-md-2 control-label">Requirements</label>
                                <div class="col-md-8">
                                    <div class="checkbox checkbox-inline">
                                        <input :disabled="undertaking.reqPa" id="reqMoaCheckbox" type="checkbox" name="reqMoa" v-model="undertaking.reqMoa" v-validate="moaPaValidationRule(undertaking.reqPa)">
                                        <label for="reqMoaCheckbox">MOA</label>
                                    </div>
                                    <div class="checkbox checkbox-inline">
                                        <input :disabled="undertaking.reqMoa" id="reqPaCheckbox" type="checkbox" name="reqPa" v-model="undertaking.reqPa" v-validate="moaPaValidationRule(undertaking.reqMoa)">
                                        <label for="reqPaCheckbox">PA</label>
                                    </div>
                                    <div class="checkbox checkbox-inline">
                                        <input id="reqDiscoveryPlanCheckbox" type="checkbox" name="reqDiscoveryPlan" v-model="undertaking.reqDiscoveryPlan">
                                        <label for="reqDiscoveryPlanCheckbox">Discovery Plan</label>
                                    </div>
                                    <div class="checkbox checkbox-inline">
                                        <input id="reqDataDiscoveryPlanCheckbox" type="checkbox" name="reqDataDiscoveryPlan" v-model="undertaking.reqDataDiscoveryPlan">
                                        <label for="reqDataDiscoveryPlanCheckbox">Data Discovery Plan</label>
                                    </div>
                                </div>
                                <span v-show="errors.has('undertaking.reqPa') || errors.has('undertaking.reqMoa')" class="has-error">Cannot check off both MOA and PA</span>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label"></label>
                                <div class="col-md-8">
                                    <div class="checkbox checkbox-inline">
                                        <input id="reqVisualContrastRatingCheckbox" type="checkbox" name="reqVisualContrastRating" v-model="undertaking.reqVisualContrastRating">
                                        <label for="reqVisualContrastRatingCheckbox">Visual Contrast Rating</label>
                                    </div>
                                    <div class="checkbox checkbox-inline">
                                        <input id="reqComplianceCheckCheckbox" type="checkbox" name="reqComplianceCheck" v-model="undertaking.reqComplianceCheck">
                                        <label for="reqComplianceCheckCheckbox">Compliance Check</label>
                                    </div>
                                    <div class="checkbox checkbox-inline">
                                        <input id="reqHabsHaerRecordCheckbox" type="checkbox" name="reqHabsHaerRecord" v-model="undertaking.reqHabsHaerRecord">
                                        <label for="reqHabsHaerRecordCheckbox">HABS/HAER Record</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('undertaking.effectId') }">
                                <label class="col-md-2 control-label">Finding of Effect for Project</label>
                                <div class="col-md-4">
                                    <select name="effectId" class="form-control" v-model="undertaking.effectId" v-validate="'required'" aria-required="true">
                                        <option :value="null">Select a value</option>
                                        <option v-for="effect in effectList" v-bind:value="effect.effectId" :key="effect.effectId">
                                            {{ effect.description}}
                                        </option>
                                    </select>
                                    <span v-show="errors.has('undertaking.effectId')" class="has-error">Finding of Effect is required</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label">Finding of Effect Notes</label>
                                <div class="col-md-8">
                                    <textarea class="form-control" rows="2" name="findingOfEffectNotes" v-model="undertaking.findingOfEffectNotes"></textarea>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label">Inventory Type</label>
                                <div class="col-md-4">
                                    <select name="inventoryType" class="form-control" v-model="undertaking.inventoryType">
                                        <option disabled :value="null">Select a value</option>
                                        <option v-for="type in inventoryTypeList" v-bind:value="type.id" :key="type.id">
                                            {{ type.description}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('undertaking.reviewFrameworkId') }">
                                <label class="col-md-2 control-label">Review Framework</label>
                                <div class="col-md-4">
                                    <select name="reviewFrameworkId" class="form-control" v-model="undertaking.reviewFrameworkId" v-validate="'required'" aria-required="true">
                                        <option :value="null">Select a value</option>
                                        <option v-for="framework in reviewFrameworkList" v-bind:value="framework.id" :key="framework.id">
                                            {{ framework.description}}
                                        </option>
                                    </select>
                                    <span v-show="errors.has('undertaking.reviewFrameworkId')" class="has-error">Review framework is required</span>
                                </div>
                            </div>
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('undertaking.reviewTimeframeId') }">
                                <label class="col-md-2 control-label">Review Timeframe</label>
                                <div class="col-md-4">
                                    <select name="reviewTimeframeId" class="form-control" v-model="undertaking.reviewTimeframeId" v-validate="'required'" aria-required="true">
                                        <option disabled :value="null">Select a value</option>
                                        <option v-for="timeframe in reviewTfFilteredList" v-bind:value="timeframe.id" :key="timeframe.id">
                                            {{ timeframe.description}}
                                        </option>
                                    </select>
                                    <span v-show="errors.has('undertaking.reviewTimeframeId')" class="has-error">Review timeframe is required</span>
                                </div>
                            </div>
                            <div class="form-group" v-show='undertaking.reviewTimeframeId'>
                                <label class="col-md-2 control-label">PLSS Location</label>
                                <div class="col-md-4">
                                    <button name="button3" class="btn btn-primary" :disabled="!undertaking.undertakingId" v-on:click="$refs['plssLocationModal'].open()">Add PLSS Locations</button>
                                    <modal title="Add Sections(s)" ref="plssLocationModal">
                                        <div slot="header">
                                            <h4>Add PLSS Locations</h4>
                                        </div>
                                        <div slot="body">
                                            <plssComponent v-on:savePlss="savePlss" ref="plssComponent" :showTitle="false" />
                                        </div>
                                        <div slot="footer">
                                            <div>
                                                <button type="button" class="btn btn-primary col-md-3" v-on:click="$refs['plssLocationModal'].close()">Close</button>
                                            </div>
                                        </div>
                                    </modal>
                                </div>
                            </div>
                            <div class="form-group" v-show='undertaking.reviewTimeframeId'>
                                <label class="col-md-2 control-label">Section List</label>
                                <div class="col-md-8">
                                    <v-client-table :data="plssLocationGridSpec.tableData" :columns="plssLocationGridSpec.columns" :options="plssLocationGridSpec.options">
                                        <template slot="delete" slot-scope="props">
                                            <div style="text-align: center;">
                                                <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deletePlssLocation(props.row.undertakingPlssLocationId)"></a>
                                            </div>
                                        </template>
                                    </v-client-table>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label">Stipulations</label>
                                <div class="col-md-8">
                                    <textarea class="form-control" rows="7" name="stipulations" v-model="undertaking.stipulations"></textarea>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label">Comments</label>
                                <div class="col-md-8">
                                    <textarea class="form-control" rows="5" name="comments" v-model="undertaking.comment"></textarea>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label">{{investigationTableLabel}}</label>
                                <div class="col-md-8">
                                    <button :disabled="!undertaking.undertakingId" class="btn btn-primary" type="button" name="assignInvestigation" v-on:click="$refs['investigationAssignModal'].open()">Assign Investigation</button>
                                    <modal ref="investigationAssignModal">
                                        <div slot="header">
                                            <h3 class="pull-left">Assign An Investigation</h3>
                                            <button class="btn pull-right" v-on:click="$refs['investigationAssignModal'].close()">X</button>
                                        </div>
                                        <div slot="body">
                                            <div>
                                                <form @submit.prevent="loadAllInvestigations" class="form-horizontal">
                                                    <div class="form-group">
                                                        <div class="col-sm-4">
                                                            <label for="searchDbNumber">DB Number</label>
                                                        </div>
                                                        <div class="col-sm-8">
                                                            <input class="form-control" type="text" name="searchDbNumber" v-model="invSearchDto.dbNumber">
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <div class="col-sm-4">
                                                            <label for="searchReportTitle">Report Title</label>
                                                        </div>
                                                        <div class="col-sm-8">
                                                            <input class="form-control" type="text" name="searchReportTitle" v-model="invSearchDto.reportTitle">
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <div class="col-sm-4">
                                                            <label for="searchAgencyNumber">Agency Number</label>
                                                        </div>
                                                        <div class="col-sm-8">
                                                            <input class="form-control" type="text" name="searchAgencyNumber" v-model="invSearchDto.agencyNumber">
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <div class="col-md-2">
                                                            <button class="btn btn-primary" type="submit" name="button">Search</button>
                                                        </div>
                                                    </div>
                                                </form>
                                                <v-client-table :data="invAllGridSpec.tableData" :columns="invAllGridSpec.columns" :options="invAllGridSpec.options">
                                                    <template slot="assign" slot-scope="props">
                                                        <div style="text-align: center;">
                                                            <button class="btn" v-on:click="assignInvestigation(props.row)">Assign</button>
                                                        </div>
                                                    </template>
                                                    <template slot="edit" slot-scope="props">
                                                        <div style="text-align: center;">
                                                            <router-link :to="{ path: '/Investigation/' + props.row.investigationId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                                                        </div>
                                                    </template>
                                                    <template slot="hasUndertaking" slot-scope="props">
                                                        <div style="text-align: center;" v-if="props.row.undertakingId">
                                                            <router-link :to="{ path: '/Undertaking/' + props.row.undertakingId }" tag="a">{{props.row.undertakingDbu}}</router-link>
                                                        </div>
                                                    </template>
                                                </v-client-table>
                                            </div>
                                        </div>
                                        <div slot="footer">
                                            <div class="row">
                                                <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="$refs['investigationAssignModal'].close()">Close</button>
                                            </div>
                                        </div>
                                    </modal>
                                    <v-client-table :data="invGridSpec.tableData" :columns="invGridSpec.columns" :options="invGridSpec.options">
                                        <template slot="edit" slot-scope="props">
                                            <div style="text-align: center;">
                                                <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editTableRow('Investigation', props.row.investigationId)"></a> -->
                                                <router-link :to="{ path: '/Investigation/' + props.row.investigationId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                                            </div>
                                        </template>
                                        <template slot="remove" slot-scope="props">
                                            <div style="text-align: center;">
                                                <button class="btn" v-on:click="removeInvestigation(props.row)">Remove</button>
                                            </div>
                                        </template>
                                    </v-client-table>
                                </div>
                            </div>
                            <div v-if="undertaking.reqMoa || moaAllGridSpec.tableData.length > 0" class="form-group">
                                <label class="col-md-2 control-label">Assigned MOA</label>
                                <div class="col-md-8">
                                    <button :disabled="!undertaking.undertakingId" class="btn btn-primary" type="button" name="assignMoa" v-on:click="$refs['moaAssignModal'].open()">Assign MOA</button>
                                    <modal ref="moaAssignModal">
                                        <div slot="header" class="">
                                            <h3 class="pull-left">Assign An MOA</h3>
                                            <button class="btn pull-right" v-on:click="$refs['moaAssignModal'].close()">X</button>
                                        </div>
                                        <div slot="body">
                                            <div class="">
                                                <div class="pull-right">
                                                    <router-link to="/Moa" tag="button" class="btn btn-primary btn-block">Create New MOA</router-link>
                                                </div>
                                                <form @submit.prevent="searchMoas" class="form-horizontal">
                                                    <div class="form-group">
                                                        <div class="col-sm-4">
                                                            <label for="searchDbNumber">Name</label>
                                                        </div>
                                                        <div class="col-sm-8">
                                                            <input class="form-control" type="text" name="searchDbNumber" v-model="moaSearchDto.name">
                                                        </div>
                                                    </div>
                                                        <div class="col-sm-4">
                                                            <label for="searchReportTitle">DB Number</label>
                                                        </div>
                                                        <div class="col-sm-8">
                                                            <input class="form-control" type="text" name="searchReportTitle" v-model="moaSearchDto.dbNumber">
                                                        </div>
                                                    <div>
                                                    </div>
                                                    <div class="form-group">
                                                        <div class="col-md-2">
                                                            <button class="btn btn-primary" type="submit" name="button">Search</button>
                                                        </div>
                                                    </div>
                                                </form>
                                                <v-client-table :data="moaAllGridSpec.tableData" :columns="moaAllGridSpec.columns" :options="moaAllGridSpec.options">
                                                    <template slot="assign" slot-scope="props">
                                                        <div style="text-align: center;">
                                                            <button class="btn" v-on:click="assignMoa(props.row)">Assign</button>
                                                        </div>
                                                    </template>
                                                </v-client-table>
                                            </div>
                                        </div>
                                        <div slot="footer">
                                            <div class="">
                                                <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="$refs['moaAssignModal'].close()">Close</button>
                                            </div>
                                        </div>
                                    </modal>
                                    <v-client-table :data="assignedMoa" :columns="moaGridSpec.columns" :options="moaGridSpec.options">
                                        <template slot="edit" slot-scope="props">
                                            <div style="text-align: center;">
                                                <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editTableRow('Moa', props.row.moaId)"></a> -->
                                                <router-link :to="{ path: '/Moa/' + props.row.moaId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                                            </div>
                                        </template>
                                        <template slot="remove" slot-scope="props">
                                            <div style="text-align: center;">
                                                <button class="btn" v-on:click="removeMoa(props.row)">Remove</button>
                                            </div>
                                        </template>
                                    </v-client-table>
                                </div>
                            </div>
                            <div v-if="undertaking.reqPa || paAllGridSpec.tableData.length > 0" class="form-group">
                                <label class="col-md-2 control-label">Assigned PA</label>
                                <div class="col-md-8">
                                    <button :disabled="!undertaking.undertakingId" class="btn btn-primary" type="button" name="assignMoa" v-on:click="$refs['paAssignModal'].open()">Assign PA</button>
                                    <modal ref="paAssignModal">
                                        <div slot="header" class="">
                                            <h3 class="pull-left">Assign An PA</h3>
                                            <button class="btn pull-right" v-on:click="$refs['paAssignModal'].close()">X</button>
                                        </div>
                                        <div slot="body">
                                            <div class="">
                                                <form @submit.prevent="searchPas" class="form-horizontal">
                                                    <div class="form-group">
                                                        <div class="col-sm-4">
                                                            <label for="searchDbNumber">Name</label>
                                                        </div>
                                                        <div class="col-sm-8">
                                                            <input class="form-control" type="text" name="searchName" v-model="paSearchDto.name">
                                                        </div>
                                                    </div>
                                                        <div class="col-sm-4">
                                                            <label for="searchReportTitle">DB Number</label>
                                                        </div>
                                                        <div class="col-sm-8">
                                                            <input class="form-control" type="text" name="searchDbNumber" v-model="paSearchDto.dbNumber">
                                                        </div>
                                                    <div>
                                                    </div>
                                                    <div class="form-group">
                                                        <div class="col-md-2">
                                                            <button class="btn btn-primary" type="submit" name="button">Search</button>
                                                        </div>
                                                    </div>
                                                </form>
                                                <v-client-table :data="paAllGridSpec.tableData" :columns="paAllGridSpec.columns" :options="paAllGridSpec.options">
                                                    <template slot="assign" slot-scope="props">
                                                        <div style="text-align: center;">
                                                            <button class="btn" v-on:click="assignPa(props.row)">Assign</button>
                                                        </div>
                                                    </template>
                                                </v-client-table>
                                            </div>
                                        </div>
                                        <div slot="footer">
                                            <div class="row">
                                                <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="$refs['paAssignModal'].close()">Close</button>
                                            </div>
                                        </div>
                                    </modal>
                                    <v-client-table :data="assignedPa" :columns="paGridSpec.columns" :options="paGridSpec.options">
                                        <template slot="edit" slot-scope="props">
                                            <div style="text-align: center;">
                                                <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editTableRow('Pa', props.row.paId)"></a> -->
                                                <router-link :to="{ path: '/Pa/' + props.row.paId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                                            </div>
                                        </template>
                                        <template slot="remove" slot-scope="props">
                                            <div style="text-align: center;">
                                                <button class="btn" v-on:click="removePa(props.row)">Remove</button>
                                            </div>
                                        </template>
                                    </v-client-table>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label">&nbsp;</label>
                                <div class="col-md-4">
                                    <validationResultDisplay :validationResult="validationResult"></validationResultDisplay>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-offset-2">
                                    <hr />
                                    <button v-if="!formDisabled" class="btn btn-primary" type="submit" name="submit" style="width:100px;" v-on:click="saveUndertaking">
                                        {{undertakingId ? 'Save' : 'Create'}}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </fieldset>
                </div>
            </tab>
            <tab header="Documents">
                <undertakingDocuments v-if="$route.params.undertakingId" :parentId="$route.params.undertakingId" :undertaking="undertaking"
                    :loadOnMount="false" :formDisabled="formDisabled" :isAdmin="isAdmin" ref="undertakingDocuments"></undertakingDocuments>
                <div style="margin-top: 20px;">
                    <hr />
                    <mediaLetter :mediaTypeId="mediaTypeIdUndLetter" :parentId="undertakingId" :loadOnMount="false" ref="mediaLetter"></mediaLetter>
                </div>
            </tab>
            <tab header="Map" :disabled="!undertakingId">
                <mapx :mediaTypeId="mediaTypeIdShapeFile" :parentId="undertakingId" :loadOnMount="false" ref="mapx"></mapx>
            </tab>
            <tab header="Cultural Resources" :disabled="!showSites">
                <culturalResourceSelectionUndertaking v-bind:undertaking="undertaking" :loadOnMount="false" :isShpo="checkShpoRole" :formDisabled="formDisabled" ref="crSelection"/>
            </tab>
            <tab header="Workflow" :disabled="!undertakingId">
                <div v-if="undertakingId" style="margin-top: 20px;">
                    <workflow :workflowId="undertakingWorkflowId" :parentId="undertakingId" ref="workflow"
                    v-on:workflowOnBeforeSubmit="saveUndertaking" v-on:workflowOnSubmitSuccess="workflowOnSubmitSuccess"/>
                </div>
                <div v-if="checkShpoRole" style="margin-top: 20px;">
                    <quickLetter :undertakingId="undertakingId" :mediaTypeId="mediaTypeIdUndLetter" :parentId="undertakingId"></quickLetter>
                </div>
                <div v-if="undertakingId">
                    <button name="undertakingReport" :disabled="reportGenLoading" class="btn btn-primary" v-on:click="genUndertakingReport">Generate Report</button>
                </div>
            </tab>
        </tabs>

    </div>
</template>

<script>
    import loggingService from '../services/util/loggingService'
    import undertakingService from '../services/undertakingService'
    import dateService from '../services/util/dateService'
    import investigationService from '@/services/investigationService'
    import moaService from '@/services/moaService'
    import paService from '@/services/paService'
    import workflowService from '../services/workflowService'
    import mediaService from '../services/mediaService'
    import roleService from '../services/roleService.js'
    import userService from '@/services/userService.js'
    import evaluationService from '@/services/siteForm/evaluationService'
    import organizationService from '@/services/organizationService'
    import lookupService from '@/services/lookup/lookupService'
    import { mapState } from 'vuex'

    import loader from '@/components/Loader.vue'
    import modal from '@/components/Modal.vue'
    import undertakingDocuments from '../components/Undertaking/UndertakingDocuments.vue'
    import culturalResourceSelectionUndertaking from './CulturalResourceSelectionUndertaking.vue'
    import validationResultDisplay from '@/components/ValidationResultDisplay.vue'
    import workflow from '../components/Workflow.vue'
    import mediaLetter from '../components/MediaLetter.vue'
    import quickLetter from '../components/QuickLetter.vue'
    import plssComponent from '../components/PlssComponent'
    import mapx from '@/views/MapNew'

    import { tab, tabs } from 'vue-strap'

    export default {
        components: {
            loader,
            tabs,
            tab,
            modal,
            undertakingDocuments,
            culturalResourceSelectionUndertaking,
            validationResultDisplay,
            workflow,
            mediaLetter,
            quickLetter,
            plssComponent,
            mapx
        },
        data: function () {
            return {
                isDebug: false,
                loading: true,
                activeTabIndex: 0,
                undertaking: {},
                assignedMoa: [],
                assignedPa: [],
                validationResult: {},
                invAssignable: [],
                invAssigned: [],
                invGridSpec: {
                    columns: ['edit', 'workflowStatusDescription', 'dbNumber', 'reportTitle', 'reportDate', 'remove'],
                    tableData: [],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 10,
                        perPageValues: [5, 10, 25, 50, 100],
                        dateColumns: ['reportDate'],
                        headings: {
                            workflowStatusDescription: 'Status',
                            dbNumber: 'DB Number',
                            reportTitle: 'Report Title',
                            reportDate: 'Report Date'
                        },
                        filterable: false,
                        orderBy: {
                            ascending: false,
                            column: 'reportDate'
                        }
                    }
                },
                invAllGridSpec: {
                    columns: ['assign', 'edit', 'workflowStatusDescription', 'dbNumber', 'reportTitle', 'reportDate', 'hasUndertaking'],
                    tableData: [],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 5,
                        perPageValues: [5, 10, 25, 50, 100],
                        dateColumns: ['reportDate'],
                        headings: {
                            workflowStatusDescription: 'Status',
                            dbNumber: 'DB Number',
                            reportTitle: 'Report Title',
                            reportDate: 'Report Date',
                            hasUndertaking: 'Assigned Undertaking',
                            edit: 'View'
                        },
                        orderBy: {
                            ascending: false,
                            column: 'reportDate'
                        }
                    }
                },
                moaGridSpec: {
                    columns: ['edit', 'moaName', 'dbnumber', 'effectiveDate', 'createdDate', 'remove'],
                    tableData: [],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 5,
                        perPageValues: [5, 10, 25, 50, 100],
                        dateColumns: ['effectiveDate', 'createdDate'],
                        headings: {
                            moaName: 'Name',
                            dbNumber: 'DB Number',
                            effectiveDate: 'Effective Date',
                            createdDate: 'Created Date'
                        },
                        orderBy: {
                            ascending: false,
                            column: 'effectiveDate'
                        },
                        filterable: false
                    }
                },
                paGridSpec: {
                    columns: ['edit', 'paName', 'dbnumber', 'effectiveDate', 'createdDate', 'remove'],
                    tableData: [],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 5,
                        perPageValues: [5, 10, 25, 50, 100],
                        dateColumns: ['effectiveDate', 'createdDate'],
                        headings: {
                            paName: 'Name',
                            dbNumber: 'DB Number',
                            effectiveDate: 'Effective Date',
                            createdDate: 'Created Date'
                        },
                        orderBy: {
                            ascending: false,
                            column: 'effectiveDate'
                        },
                        filterable: false
                    }
                },
                moaAllGridSpec: {
                    columns: ['assign', 'moaName', 'dbnumber', 'effectiveDate', 'createdDate'],
                    tableData: [],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 5,
                        perPageValues: [5, 10, 25, 50, 100],
                        dateColumns: ['effectiveDate', 'createdDate'],
                        headings: {
                            moaName: 'Name',
                            dbNumber: 'DB Number',
                            effectiveDate: 'Effective Date',
                            createdDate: 'Created Date'
                        },
                        orderBy: {
                            ascending: false,
                            column: 'effectiveDate'
                        }
                    }
                },
                paAllGridSpec: {
                    columns: ['assign', 'paName', 'dbnumber', 'effectiveDate', 'createdDate'],
                    tableData: [],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 5,
                        perPageValues: [5, 10, 25, 50, 100],
                        dateColumns: ['effectiveDate', 'createdDate'],
                        headings: {
                            moaName: 'Name',
                            dbNumber: 'DB Number',
                            effectiveDate: 'Effective Date',
                            createdDate: 'Created Date'
                        },
                        orderBy: {
                            ascending: false,
                            column: 'effectiveDate'
                        }
                    }
                },
                tabsEnum: {
                    undertaking: 0,
                    documents: 1,
                    documentsLoaded: false,
                    map: 2,
                    mapLoaded: false,
                    crr: 3,
                    crrLoaded: false,
                    workflow: 4,
                    workflowLoaded: false
                },
                //effectList: evaluationService.UndertakingEffectList,
                invSearchDto: {
                    showOnlyUndertakingUnassigned: true,
                    showOnlyUndertakingReady: true
                },
                moaSearchDto: {},
                paSearchDto: {},
                agencyOrgList: [],
                reviewTimeframeList: [],
                plssLocationGridSpec: {
                    columns: ['meridianDescription', 'locationDescription', 'section', 'delete'],
                    tableData: [],
                    options: {
                        perPage: 10,
                        perPageValues: [10, 25, 50, 100],
                        headings: {
                            meridianDescription: 'Meridian',
                            locationDescription: 'Township',
                            section: 'Section',
                            delete: 'Delete'
                        },
                        filterable: false
                    }
                },
                agencyOrgTypeEnum: {
                    none: 'none',
                    blm: 'blm',
                    usfs: 'usfs',
                    nrcs: 'nrcs'
                },
                inventoryTypeList: undertakingService.InventoryTypeList,
                reportGenLoading: false
            }
        },
        watch: {
            activeTabIndex: function (val) {
                loggingService.log(this.isDebug, 'Undertaking', 'watch.activeTabIndex: ' + val)
                switch (val) {
                case this.tabsEnum.undertaking:
                    break
                case this.tabsEnum.documents: //Documents
                    if (!this.tabsEnum.documentsLoaded) {
                        this.$refs.undertakingDocuments.loadData()
                        this.$refs.mediaLetter.loadMedia()
                    }
                    this.tabsEnum.documentsLoaded = true
                    break
                case this.tabsEnum.map:
                    if (!this.tabsEnum.mapLoaded) this.$refs.mapx.createMap()
                    this.tabsEnum.mapLoaded = true
                    break
                case this.tabsEnum.workflow: //Workflow
                    if (!this.tabsEnum.workflowLoaded) {
                        this.$refs.workflow.loadData()
                        loggingService.log(this.isDebug, 'Undertaking', 'watch.activeTabIndex: ' + val + ', called: workflow.loadData')
                    }
                    this.tabsEnum.workflowLoaded = true
                    break
                case this.tabsEnum.crr: //Cultural Resource Recording
                    if (!this.tabsEnum.crrLoaded) {
                        this.$refs.crSelection.loadData()
                        loggingService.log(this.isDebug, 'Undertaking', 'watch.activeTabIndex: ' + val + ', called: culturalResourceSelectionUndertaking.loadData')
                    }
                    this.tabsEnum.crrLoaded = true
                    break
                }
            },
            'undertaking.inventoryType': function () {
                this.previousCurrentInvCheck()
            }
        },
        computed: {
            undertakingId: function () {
                return this.$route.params.undertakingId
            },
            undertakingWorkflowId: function () {
                return workflowService.WorkflowEnum.Undertaking
            },
            mediaTypeIdUndLetter: function () {
                return mediaService.mediaType.UndertakingLetter
            },
            mediaTypeIdShapeFile: function () {
                return mediaService.mediaType.UndertakingShapeFiles.toString()
            },
            // compute current user info
            ...mapState({
                shpoUserDto: state => state.auth.shpoUserDto
            }),
            isAdmin: function () {
                var roleList = [roleService.RoleEnum.Administrator, roleService.RoleEnum.ShpoAdministrator, roleService.RoleEnum.ShpoRcAdministrator]
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleList))
            },
            checkShpoRole: function () {
                var shpoRoleList = [
                    roleService.RoleEnum.Administrator,
                    roleService.RoleEnum.ShpoAdministrator,
                    roleService.RoleEnum.ShpoCrApprovingUser,
                    roleService.RoleEnum.ShpoCrDataEntryUser,
                    roleService.RoleEnum.ShpoRcAdministrator,
                    roleService.RoleEnum.ShpoRcApprovingUser,
                    roleService.RoleEnum.ShpoRcDataEntryUser
                ]
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, shpoRoleList))
            },
            showSites: function () {
                var effectExempt = this.effectList.find(e => e.description === 'Exempt')
                return (this.undertaking.inventoryType || 1) !== 1 ||
                    (effectExempt && effectExempt.effectId === this.undertaking.effectId)
            },
            leadAgencyType: function () {
                var leadAgencyOrg = this.agencyOrgList.find(o => o.id === this.undertaking.agencyId)
                if (leadAgencyOrg) {
                    if (leadAgencyOrg.isBlm) return this.agencyOrgTypeEnum.blm
                    if (leadAgencyOrg.isUsfs) return this.agencyOrgTypeEnum.usfs
                    if (leadAgencyOrg.description.includes('Natural Resources Conservation')) return this.agencyOrgTypeEnum.nrcs
                }
                return this.agencyOrgTypeEnum.none
            },
            reviewFrameworkList: function () {
                var filteredList = undertakingService.ReviewFrameworkList.filter(x => (x.type === this.leadAgencyType || x.type === 'none'))
                if (this.undertaking.effectId === 4) {
                    filteredList = filteredList.filter(x => x.type !== 'none')
                }
                return filteredList
            },
            reviewTfFilteredList: function () {
                //if PA is selected, show all timeframes
                if (this.undertaking.reqPa) return this.reviewTimeframeList
                //if effect === exempt, only show Notify and Proceed
                if (this.undertaking.effectId === 4) return this.reviewTimeframeList.filter(x => x.description.includes('Notify'))
                //When review framework is a standard S106 only show 30day for time frame.
                if (this.undertaking.reviewFrameworkId === 99) {
                    return this.reviewTimeframeList.filter(x => x.description === '30 Day' || x.description === '7 Day')
                }

                var filteredList = this.reviewTimeframeList
                if (this.leadAgencyType === 'usfs' || this.leadAgencyType === 'nrcs') {
                    filteredList = filteredList.filter(x => x.description.includes('Notify') || x.description === '30 Day' || x.description === '7 Day')
                }
                // if (this.leadAgencyType === 'nrcs') {
                //     return this.reviewTimeframeList.filter(x => (x.description.includes('Notify') || x.description === '15 Day' || x.description === '30 Day'))
                // }

                //if adverse effect and no PA selected and attached, remove "Notify and Proceed"
                if (this.undertaking.effectId === 3) {
                    filteredList = filteredList.filter(x => !x.description.includes('Notify'))
                }

                return filteredList
            },
            effectList: function () {
                var list = evaluationService.UndertakingEffectList
                if (!this.checkShpoRole) {
                    list = list.filter(x => x.effectId !== 1)
                }
                //2021-07-26: no longer requred. remove "adverse effect" if inventory type is not "New"
                // if ((this.undertaking.inventoryType || 1) !== 1) {
                //     list = list.filter(x => x.effectId !== 3)
                // }
                return list
            },
            isSubmitted: function () {
                return (this.undertaking && this.undertaking.currentWorkflowStatusId && this.undertaking.currentWorkflowStatusId > 8000)
            },
            formDisabled: function () {
                return this.isSubmitted && !this.isAdmin
            },
            investigationTableLabel: function () {
                if (this.undertaking.inventoryType === 2 || this.undertaking.inventoryType === 4) {
                    return 'Previous Investigations'
                } else if (this.undertaking.inventoryType === 3) {
                    return 'Previous/Current Investigations'
                } else {
                    return 'Investigations'
                }
            },
            selectedLeadAgency: function () {
                return this.agencyOrgList.find(o => o.id === this.undertaking.agencyId)
            }
        },
        mounted () {
            loggingService.log(this.isDebug, 'Undertakings', 'mounted')
            Promise.all([this.loadLookups(), this.loadData()]).then(response => {
                this.loading = false
            })
        },
        methods: {
            loadData () {
                loggingService.log(this.isDebug, 'Undertaking', `loading data undertaking:${this.$route.params.undertakingId}`)
                if (this.$route.params.undertakingId) {
                    undertakingService.get(this.$http, this.$route.params.undertakingId).then(response => {
                        loggingService.log(this.isDebug, 'Undertaking', 'undertakingService.get.then')
                        this.undertaking = response.data
                        this.undertaking.inventoryType = this.undertaking.inventoryType || 1
                        //Set assigned investigations
                        this.invAssigned = this.undertaking.investigationList
                        if (this.invAssigned) {
                            this.invAssigned.forEach(row => {
                                row.reportDate = dateService.convertToDate(row.reportDate)
                            })
                        }
                        this.previousCurrentInvCheck()

                        //if undertaking has no agencyId, set the first assigned investigation --> project's agencyId
                        if (!this.undertaking.agencyId && this.invGridSpec.tableData.length > 0) {
                            this.undertaking.agencyId = this.invGridSpec.tableData[0].projectAgencyId
                        }
                        // load plss locations
                        this.loadPlssLocationResultList()
                        // load the assigned MOA or PA
                        this.loadAssignedMoaPa()
                        //this.loadAllMoasPas()
                        this.loadAllInvestigations()
                        return response
                    })
                } else {
                    loggingService.log(this.isDebug, 'Undertaking', 'new undertaking')
                    this.createNewUndertaking()
                    return
                }
            },
            createNewUndertaking () {
                this.undertaking = {
                    name: '',
                    agencyId: this.populateAgency(),
                    agencyUndertakingNo: '',
                    reqMoa: false,
                    reqPa: false,
                    reqDiscoveryPlan: false,
                    reqDataDiscoveryPlan: false,
                    reqVisualContrastRating: false,
                    reqComplianceCheck: false,
                    reqHabsHaerRecord: false,
                    stipulations: '',
                    comment: '',
                    inventoryType: 1
                }
            },
            populateAgency: function () {
                loggingService.log(this.isDebug, 'Undertaking', 'new Undertaking - populating lead agency')
                if (this.shpoUserDto.roleList.includes(roleService.RoleEnum.BlmUser) && (this.shpoUserDto.userOrganizationList.length > 0)) {
                    return this.shpoUserDto.userOrganizationList[0].organizationId
                } else {
                    return null
                }
            },
            loadAgencyList () {
                return organizationService.listLeadAgencyLookup(this.$http).then(response => {
                    this.agencyOrgList = response.data
                    return response
                })
            },
            loadReviewTimeframeList () {
                return lookupService.listLookup(this.$http, 'ReviewTimeframe').then(response => {
                    this.reviewTimeframeList = response.data
                    return response
                })
            },
            loadLookups () {
                Promise.all([this.loadAgencyList(), this.loadReviewTimeframeList()]).then(response => {
                    return response
                })
            },
            loadAllInvestigations () {
                loggingService.log(this.isDebug, 'Undertaking', 'loadAllInvestigation')
                this.invSearchDto.showOnlyUndertakingUnassigned = false
                this.invSearchDto.showOnlyUndertakingReady = true
                this.invSearchDto.showInactive = false
                investigationService.search(this.$http, this.invSearchDto).then(response => {
                    response.data.forEach(investigation => {
                        investigation.reportDate = dateService.convertToDate(investigation.reportDate)
                    })
                    this.invAssignable = response.data
                    this.previousCurrentInvCheck()
                    return response
                })
            },
            // load the assigned MOA or PA if there is one
            loadAssignedMoaPa () {
                if (this.undertaking.moaId) {
                    loggingService.log(this.Debug, 'Undertaking', 'load assigned MOA')
                    moaService.get(this.$http, this.undertaking.moaId).then(response => {
                        response.data.effectiveDate = dateService.convertToDate(response.data.effectiveDate)
                        response.data.createdDate = dateService.convertToDate(response.data.createdDate)
                        this.assignedMoa = [response.data]
                    })
                }
                if (this.undertaking.paId) {
                    loggingService.log(this.Debug, 'Undertaking', 'load assigned PA')
                    paService.get(this.$http, this.undertaking.paId).then(response => {
                        response.data.effectiveDate = dateService.convertToDate(response.data.effectiveDate)
                        response.data.createdDate = dateService.convertToDate(response.data.createdDate)
                        this.assignedPa = [response.data]
                    })
                }
                return
            },
            // loadAllMoasPas () {
            //     loggingService.log(this.Debug, 'Undertaking', 'load all MOAs and PAs')
            //     moaService.searchUnassigned(this.$http, {}).then(response => {
            //         this.moaAllGridSpec.tableData = response.data
            //         //search all unassigned PA
            //         paService.searchUnassigned(this.$http, {}).then(response => {
            //             this.paAllGridSpec.tableData = response.data
            //         })
            //     })
            // },
            searchMoas () {
                moaService.search(this.$http, this.moaSearchDto).then(response => {
                    this.moaAllGridSpec.tableData = response.data
                })
            },
            searchPas () {
                paService.search(this.$http, this.paSearchDto).then(response => {
                    this.paAllGridSpec.tableData = response.data
                })
            },
            loadPlssLocationResultList () {
                if (this.undertaking.undertakingId) {
                    loggingService.log(this.isDebug, 'Undertaking', 'loadPlssLocationResultList')
                    undertakingService.listUndertakingPlssLocationResultDto(this.$http, this.undertaking.undertakingId).then(response => {
                        this.plssLocationGridSpec.tableData = response.data
                    })
                }
            },
            savePlss () {
                if (this.undertaking.undertakingId) {
                    var plss = this.$refs['plssComponent'].plssData
                    undertakingService.putPlss(this.$http, this.undertaking.undertakingId, plss).then(response => {
                        loggingService.log(this.isDebug, 'Undertaking', 'savePlss - complete')
                        this.loadPlssLocationResultList()
                        this.$refs['plssLocationModal'].close()
                    })
                }
            },
            deletePlssLocation (undertakingId) {
                loggingService.log(this.isDebug, 'Undertaking', 'delete plss Location :' + undertakingId)
                undertakingService.deletePlssLocation(this.$http, undertakingId).then(response => {
                    this.loadPlssLocationResultList()
                })
            },
            editTableRow (routeName, id) {
                loggingService.log(this.isDebug, 'Investigations', 'editRow, id: ' + id)
                this.$router.push(`/${routeName}/` + id)
            },
            saveUndertaking () {
                this.$validator.validateAll('undertaking').then(result => {
                    if (result) {
                        this.loading = true
                        undertakingService.put(this.$http, this.undertaking).then(response => {
                            if (response.data.isValid) {
                                loggingService.log(this.isDebug, 'Undertaking', 'undertaking saved')
                                this.$validator.clean()
                                // ensure the page goes to the correct undertaking id route after creating a new undertaking
                                if (response.data.objectList && response.data.objectList.length > 0) {
                                    this.$router.push('/Undertaking/' + response.data.objectList[0].undertakingId)
                                    this.loadData()
                                    this.loading = false
                                }
                            } else {
                                // if server validation failed, send result to validationResult & validationResultDisplay
                                loggingService.log(this.isDebug, 'Undertaking', 'server validation failed')
                                this.validationResult = response.data
                                this.loading = false
                            }
                        })
                    } else {
                        loggingService.log(this.isDebug, 'UndertakingModal', 'submit - invalid form')
                    }
                })
            },
            removeInvestigation (inv) {
                if (confirm('Are you sure you want to remove this Investigation from the Undertaking?')) {
                    // create the setUndertaking object
                    var investigationSetUndertaking = {
                        investigationId: inv.investigationId,
                        undertakingId: this.undertaking.undertakingId
                    }
                    // update investigation with the setUndertaking object
                    investigationService.removeUndertaking(this.$http, investigationSetUndertaking).then(response => {
                        loggingService.log(this.isDebug, 'Undertaking', 'investigation removed from undertaking')
                        this.saveUndertaking()
                    })
                }
            },
            assignInvestigation (inv) {
                if (confirm('Are you sure you want to assign this Investigation to the Undertaking?')) {
                    var investigationSetUndertaking = {
                        investigationId: inv.investigationId,
                        undertakingId: this.undertaking.undertakingId
                    }
                    investigationService.setUndertaking(this.$http, investigationSetUndertaking).then(response => {
                        loggingService.log(this.isDebug, 'Undertaking', 'investigation added to undertaking')
                        this.$refs['investigationAssignModal'].close()
                        this.saveUndertaking()
                    })
                }
            },
            moaPaValidationRule (moaPa) {
                var expression = {
                    rules: {
                        not_in: []
                    }
                }
                if (moaPa) {
                    expression.rules.not_in = [true]
                }
                return expression
            },
            assignMoa (moa) {
                if (confirm('Are you sure you want to assign this MOA to the Undertaking?')) {
                    if (this.undertaking.paId) {
                        return alert('PA is assigned to this Undertaking, cannot assign MOA')
                    }
                    this.undertaking.moaId = moa.moaId
                    this.$refs['moaAssignModal'].close()
                    this.saveUndertaking()
                }
            },
            removeMoa (moa) {
                if (confirm('Are you sure you want to remove this MOA to the Undertaking?')) {
                    this.undertaking.moaId = null
                    this.assignedMoa = []
                    this.saveUndertaking()
                }
            },
            assignPa (pa) {
                if (confirm('Are you sure you want to assign this PA to the Undertaking?')) {
                    if (this.undertaking.moaId) {
                        return alert('PA is assigned to this Undertaking, cannot assign MOA')
                    }
                    this.undertaking.paId = pa.paId
                    this.$refs['paAssignModal'].close()
                    this.saveUndertaking()
                }
            },
            removePa (pa) {
                if (confirm('Are you sure you want to remove this PA to the Undertaking?')) {
                    this.undertaking.paId = null
                    this.assignedPa = []
                    this.saveUndertaking()
                }
            },
            workflowOnSubmitSuccess (submitValidationResult) {
                this.loadData()
                //trigger media letter refresh if letter gen is triggered
                if (submitValidationResult.letterGenTriggered && this.$refs.mediaLetter) {
                    this.$refs.mediaLetter.autoRefreshMedia()
                }
            },
            genUndertakingReport () {
                this.reportGenLoading = true
                if (this.undertaking.undertakingId) {
                    undertakingService.undertakingReportGen(this.$http, this.undertaking.undertakingId).then(response => {
                        mediaService.saveFileToDownload(response, 'UndertakingReport.pdf')
                        this.reportGenLoading = false
                    })
                }
            },
            previousCurrentInvCheck () {
                if (this.undertaking.inventoryType === 2 || this.undertaking.inventoryType === 4) {
                    this.invGridSpec.tableData = this.invAssigned
                    this.invAllGridSpec.tableData = this.invAssignable.filter(i =>
                        i.workflowStatusDescription === 'Pending QA/QC' || i.workflowStatusDescription === 'Review Completed')
                } else {
                    var inclCompleted = this.undertaking.inventoryType === 3
                    this.invGridSpec.tableData = this.invAssigned
                    this.invAllGridSpec.tableData = this.invAssignable.filter(i =>
                        i.undertakingId === null ||
                        (inclCompleted &&
                            (i.workflowStatusDescription === 'Pending QA/QC' || i.workflowStatusDescription === 'Review Completed')
                        )
                    )
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Undertaking.vue?d3d8dc6e